import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { CheckCircle2, Flag } from 'lucide-react';
import { ICON_PX } from '../../ui';

/**
 * Friendly completion node — celebratory when done.
 */
function EndNode({ data, selected }) {
  const { label, status = 'pending' } = data;
  const isSatisfied = status === 'satisfied';

  return (
    <>
      <Handle type="target" position={Position.Top} className="!bg-[var(--slate)] !w-2.5 !h-2.5 !border-2 !border-white !rounded-full" />

      <div
        className={[
          'flex items-center gap-2 rounded-full border-2 px-5 py-2.5 transition-all',
          isSatisfied
            ? 'bg-[var(--green)] border-[var(--green)] shadow-md'
            : 'bg-white border-slate-200 shadow-sm',
          selected ? 'ring-2 ring-aqua ring-offset-2' : '',
        ].join(' ')}
      >
        {isSatisfied ? (
          <CheckCircle2 size={ICON_PX.md} className="text-white" />
        ) : (
          <Flag size={ICON_PX.md} className="text-slate-400" />
        )}
        <span className={`text-sm font-semibold ${isSatisfied ? 'text-white' : 'text-slate-500'}`}>
          {isSatisfied ? 'All Done!' : (label || 'Finish')}
        </span>
      </div>
    </>
  );
}

export default memo(EndNode);
